import _sharedReducerSupport, { _sharedStateSupport } from "@/shared/store/support/reducer";

export const initialState = {
  ..._sharedStateSupport,
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return _sharedReducerSupport(state, action);
  }
};
